module.exports = __webpack_public_path__ + "img/logo-blue-new.2b37dedb.png";